import { useContext } from "react";

import { LinkButton } from "@components";

import { WorkbenchContext } from "@pages/editor/providers";

interface Props {
  line: number;
}

export const LineNumber = ({ line }: Props) => {
  const { workbench } = useContext(WorkbenchContext);
  return (
    <LinkButton
      style={{ padding: 0 }}
      onClick={() => workbench.editors.focusTargetLine(line)}
    >
      ⬆Line {line}
    </LinkButton>
  );
};
